import { EMR_APIS } from "@/api_framework/api_config";
import { IAIGenerateSummaryResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => { });

export const useAIGenerateSummaryAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const toggleLoading = (status: boolean) => {
    dispatch(
      setLoading({
        key: "isAIGenerateSummaryInProgress",
        status,
      }),
    );
  };

  const execute = useCallback(
    async (petId: string): Promise<IAIGenerateSummaryResponse | null> => {
      toggleLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios
          .post(`${EMR_APIS?.AI_GENERATE_SUMMARY?.baseURL}${petId}`, {}, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "text/plain",
            },
          })
          .then((res: AxiosResponse<IAIGenerateSummaryResponse>) => {
            toggleLoading(false);
            console.log("API Response:", res.data);
            if (res.data && res.data.data) {
              toast.success(res.data.message || "AI Summary generated successfully!");
              return res.data;
            } else {
              // toast.error(res.data.message || "Failed to generate AI summary");
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            toggleLoading(false);
            // Simply show the API message if it exists
            const apiMessage = (e.response?.data as any)?.message;
            toast.error(apiMessage || "Failed to generate AI summary");

            return null;
          });

        return response;
      } catch (e: any) {
        toggleLoading(false);
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch, configuration.localStorage.ACCESS_TOKEN.key],
  );

  return { execute };
}; 